let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("020tD")).then(() => parcelRequire('f2RT5'));